<template>
    <div>
        <Header></Header>
        <section class="section">
            <div class="columns">
                <div class="column"></div>
                <div class="column">
                    <b-tabs class="block">
                        <b-tab-item label="Единая регистрация по всем магазинам UltraShop.Uz">
                            <section>
                                <b-field label="Полное имя" type="is-warning">
                                    <b-input
                                            placeholder="Адхам Абидов"
                                            v-model="form.full_name"
                                    ></b-input>
                                </b-field>

                                <b-field label="Email"
                                         type="is-warning"
                                >
                                    <b-input type="email"
                                             v-model="form.email"
                                             maxlength="30">
                                    </b-input>
                                </b-field>
                                <b-field label="Пароль" type="is-warning">
                                    <b-input
                                            v-model="form.password"
                                            type="password"
                                            maxlength="30"
                                    ></b-input>
                                </b-field>
                                <b-field label="Повторите пароль" type="is-warning">
                                    <b-input
                                            v-model="form.password2"
                                            type="password"
                                            maxlength="30"
                                    ></b-input>
                                </b-field>
                                <button class="button is-warning" @click="signUp">Зарегистрироваться</button>
                            </section>
                        </b-tab-item>
                        <!--<b-tab-item label="Войти">-->
                        <!--ал;сдфжкалскдфж ;аклсдф-->
                        <!--</b-tab-item>-->
                    </b-tabs>
                </div>
                <div class="column"></div>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from "../../components/header/Header";
    import {API_URL} from "../../../main";
    import axios from 'axios'

    export default {
        name: "Register",
        components: {Header},
        data() {
            return {
                form: {
                    full_name: '',
                    password: '',
                    password2: '',
                    email: '',
                },
                error: null,
            }
        },
        computed: {

        },
        methods: {
            signUp() {
                axios.post(API_URL + '/users/create',
                    this.form
                )
                // .then(response => {console.log(response)})
                // .catch(response => {console.log(response)})
            }
            },

    }
</script>
<style scoped>
</style>